export const CLIEN_VIEW_UNMOUNT = 'CLIENT_VIEW_UNMOUNT'

export const GET_CLIENTS = 'GET_CLIENTS'
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS'

export const GET_CLIENT_BY_ID = 'GET_CLIENT_BY_ID'
export const GET_CLIENT_BY_ID_SUCCESS = 'GET_CLIENT_BY_ID_SUCCESS'
export const RESET_CLIENT_BY_ID = 'RESET_CLIENT_BY_ID'

export const UPDATE_CLIENT_BY_ID = 'UPDATE_CLIENT_BY_ID'
export const UPDATE_CLIENT_BY_ID_SUCCESS = 'UPDATE_CLIENT_BY_ID_SUCCESS'

export const CREATE_CLIENT = 'CREATE_CLIENT'
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS'

export const SET_STATUS_FILTER = 'SET_STATUS_FILTER'

export const STATUS_FILTER = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  ALL: 'all',
}
